/*
 * CUSTOM MEGA MENU — progressive enhancement over Dawn's native mega menu.
 * 1) Opens the panel on hover (desktop, pointer devices) instead of click.
 * 2) Injects a "featured" column of image tiles (from window.HohMega) beside
 *    the category links, giving the competitor's links-left / images-right look.
 * Adds no stock-Dawn edits; loaded globally via the Custom Theme Styles section.
 */
(function () {
  var HOVER = window.matchMedia('(hover: hover) and (min-width: 990px)');

  function enhance(details) {
    var host = details.closest('header-menu') || details;
    var summary = details.querySelector('summary');

    // --- Hover open/close (desktop pointer only) ---
    var closeTimer;
    function open() {
      if (!HOVER.matches) return;
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      alignLinks();
    }
    function close() {
      if (!HOVER.matches) return;
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, 140);
    }
    host.addEventListener('mouseenter', open);
    host.addEventListener('mouseleave', close);
    // Keep keyboard/click behaviour intact; just cancel a pending hover-close on focus.
    host.addEventListener('focusin', function () { clearTimeout(closeTimer); });

    injectFeatured(details);
  }

  function injectFeatured(details) {
    var data = window.HohMega && window.HohMega.featured;
    if (!data || !data.length) return;

    var content = details.querySelector('.mega-menu__content');
    var list = content && content.querySelector('.mega-menu__list');
    if (!content || !list || content.querySelector('.custom-mega')) return;

    var wrap = document.createElement('div');
    wrap.className = 'custom-mega page-width';

    // Prepend a bold "View All" lead-in link, like the competitor
    if (!list.querySelector('.custom-mega__viewall')) {
      var vaLi = document.createElement('li');
      var va = document.createElement('a');
      va.className = 'mega-menu__link--level-2 custom-mega__viewall';
      va.href = (window.HohMega && window.HohMega.viewAllUrl) || '/collections/all';
      va.textContent = 'View All';
      vaLi.appendChild(va);
      list.insertBefore(vaLi, list.firstChild);
    }

    var linksCol = document.createElement('div');
    linksCol.className = 'custom-mega__links';
    list.classList.remove('page-width');
    linksCol.appendChild(list); // move existing category links into the left column

    var feat = document.createElement('div');
    feat.className = 'custom-mega__featured';
    data.forEach(function (item) {
      if (!item || !item.img) return;
      var a = document.createElement('a');
      a.className = 'custom-mega__tile';
      a.href = item.url || '#';
      var img = document.createElement('img');
      img.src = item.img;
      img.alt = item.label || '';
      img.loading = 'lazy';
      a.appendChild(img); // images already carry their baked-in label
      feat.appendChild(a);
    });

    wrap.appendChild(linksCol);
    wrap.appendChild(feat);
    content.appendChild(wrap);
  }

  // Shift the links column so "View All" starts under the first nav item
  // ("New In"), since the nav is centered while the panel is full-width.
  function alignLinks() {
    var megas = document.querySelectorAll('.mega-menu__content .custom-mega');
    // Reset first so we measure the panel's true (page-width) left edge.
    megas.forEach(function (m) { m.style.paddingLeft = ''; });
    if (!HOVER.matches) return;
    var firstNav = document.querySelector('.header__inline-menu .header__menu-item');
    if (!firstNav) return;
    var navLeft = firstNav.getBoundingClientRect().left;
    megas.forEach(function (mega) {
      var pad = navLeft - mega.getBoundingClientRect().left;
      // Only nudge right, and never so far that the images would be squeezed.
      if (pad > 0 && pad < mega.clientWidth * 0.5) {
        mega.style.paddingLeft = pad + 'px';
      }
    });
  }

  function init() {
    document.querySelectorAll('header-menu > details.mega-menu').forEach(enhance);
    alignLinks();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(alignLinks, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
